class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

    if (facetForm) {
      facetForm.addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      );
    }

    const facetWrapper = this.querySelector(
      '#FacetsWrapperDesktop'
    );

    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(
        searchParams,
        null,
        false
      );
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document
      .querySelectorAll('.js-facet-remove')
      .forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true
  ) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer =
      document.getElementById('ProductCount');
    const countContainerDesktop =
      document.getElementById('ProductCountDesktop');
    const productGridContainer =
      document.getElementById('ProductGridContainer');

    if (productGridContainer) {
      const collection =
        productGridContainer.querySelector('.collection');

      if (collection) {
        collection.classList.add('loading');
      }
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url =
        `${window.location.pathname}` +
        `?section_id=${section.section}&${searchParams}`;

      const filterDataUrl = (element) =>
        element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(
          filterDataUrl,
          event
        );
      } else {
        FacetFiltersForm.renderSectionFromFetch(
          url,
          event
        );
      }
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url }
        ];

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((error) => {
        console.error('Collection filtering error:', error);

        const collection =
          document.querySelector(
            '#ProductGridContainer .collection'
          );

        if (collection) {
          collection.classList.remove('loading');
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cachedData =
      FacetFiltersForm.filterData.find(filterDataUrl);

    if (!cachedData) return;

    const html = cachedData.html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const currentContainer =
      document.getElementById('ProductGridContainer');

    const parsedHTML =
      new DOMParser().parseFromString(html, 'text/html');

    const newContainer =
      parsedHTML.getElementById('ProductGridContainer');

    if (!currentContainer || !newContainer) return;

    currentContainer.innerHTML = newContainer.innerHTML;

    window.setTimeout(() => {
      initializeCollectionElements();
    }, 0);
  }

  static renderProductCount(html) {
    const parsedHTML =
      new DOMParser().parseFromString(html, 'text/html');

    const sourceCount =
      parsedHTML.getElementById('ProductCount');

    const container =
      document.getElementById('ProductCount');

    const containerDesktop =
      document.getElementById('ProductCountDesktop');

    if (!sourceCount || !container) return;

    container.innerHTML = sourceCount.innerHTML;
    container.classList.remove('loading');

    if (containerDesktop) {
      containerDesktop.innerHTML = sourceCount.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML =
      new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, ' +
        '#FacetFiltersFormMobile .js-filter, ' +
        '#FacetFiltersPillsForm .js-filter'
      );

    const matchesIndex = (element) => {
      const jsFilter =
        event && event.target
          ? event.target.closest('.js-filter')
          : null;

      return jsFilter
        ? element.dataset.index ===
            jsFilter.dataset.index
        : false;
    };

    const facetsToRender =
      Array.from(facetDetailsElements).filter(
        (element) => !matchesIndex(element)
      );

    const countsToRender =
      Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const currentElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );

      if (currentElement) {
        currentElement.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (
      countsToRender &&
      event &&
      event.target
    ) {
      const targetFilter =
        event.target.closest('.js-filter');

      if (targetFilter) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          targetFilter
        );
      }
    }
  }

  static renderActiveFacets(html) {
    const selectors = [
      '.active-facets-mobile',
      '.active-facets-desktop'
    ];

    selectors.forEach((selector) => {
      const sourceElement =
        html.querySelector(selector);

      const targetElement =
        document.querySelector(selector);

      if (!sourceElement || !targetElement) return;

      targetElement.innerHTML =
        sourceElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const selectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting'
    ];

    selectors.forEach((selector) => {
      const sourceElement =
        html.querySelector(selector);

      const targetElement =
        document.querySelector(selector);

      if (!sourceElement || !targetElement) return;

      targetElement.innerHTML =
        sourceElement.innerHTML;
    });

    const mobileForm =
      document.getElementById(
        'FacetFiltersFormMobile'
      );

    if (mobileForm) {
      const menuDrawer =
        mobileForm.closest('menu-drawer');

      if (
        menuDrawer &&
        typeof menuDrawer.bindEvents === 'function'
      ) {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const targetElement =
      target.querySelector('.facets__selected');

    const sourceElement =
      source.querySelector('.facets__selected');

    const targetElementAccessibility =
      target.querySelector('.facets__summary');

    const sourceElementAccessibility =
      source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      targetElement.outerHTML =
        sourceElement.outerHTML;
    }

    if (
      targetElementAccessibility &&
      sourceElementAccessibility
    ) {
      targetElementAccessibility.outerHTML =
        sourceElementAccessibility.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const newURL =
      `${window.location.pathname}` +
      `${searchParams ? `?${searchParams}` : ''}`;

    history.pushState(
      { searchParams },
      '',
      newURL
    );
  }

  static getSections() {
    const productGrid =
      document.getElementById('product-grid');

    if (!productGrid || !productGrid.dataset.id) {
      return [];
    }

    return [
      {
        section: productGrid.dataset.id
      }
    ];
  }

  createSearchParams(form) {
    if (!form) {
      return '';
    }

    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(
      searchParams,
      event
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms =
      document.querySelectorAll(
        'facet-filters-form form'
      );

    const currentForm =
      event.target.closest('form');

    if (!currentForm) return;

    if (
      event.target.classList.contains(
        'mobile-facets__checkbox'
      )
    ) {
      const searchParams =
        this.createSearchParams(currentForm);

      this.onSubmitForm(searchParams, event);
      return;
    }

    const forms = [];
    const isMobile =
      currentForm.id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortDrawerForm'
        ) {
          forms.push(
            this.createSearchParams(form)
          );
        }
      } else if (
        form.id === 'FacetFiltersFormMobile'
      ) {
        forms.push(
          this.createSearchParams(form)
        );
      }
    });

    this.onSubmitForm(
      forms.filter(Boolean).join('&'),
      event
    );
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const href = event.currentTarget.href;

    const url =
      href.indexOf('?') === -1
        ? ''
        : href.slice(href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

if (
  !customElements.get('facet-filters-form')
) {
  customElements.define(
    'facet-filters-form',
    FacetFiltersForm
  );

  FacetFiltersForm.setListeners();
}

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach(
      (element) => {
        element.addEventListener(
          'change',
          this.onRangeChange.bind(this)
        );
      }
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');

    if (inputs.length < 2) return;

    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute(
        'max',
        maxInput.value
      );
    }

    if (minInput.value) {
      maxInput.setAttribute(
        'min',
        minInput.value
      );
    }

    if (minInput.value === '') {
      maxInput.setAttribute('min', 0);
    }

    if (maxInput.value === '') {
      minInput.setAttribute(
        'max',
        maxInput.getAttribute('max')
      );
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) {
      input.value = min;
    }

    if (value > max) {
      input.value = max;
    }
  }
}

if (!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    PriceRange
  );
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    if (!facetLink) return;

    facetLink.setAttribute('role', 'button');

    facetLink.addEventListener(
      'click',
      this.closeFilter.bind(this)
    );

    facetLink.addEventListener(
      'keyup',
      (event) => {
        if (
          event.code.toUpperCase() === 'SPACE'
        ) {
          event.preventDefault();
          this.closeFilter(event);
        }
      }
    );
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest('facet-filters-form') ||
      document.querySelector(
        'facet-filters-form'
      );

    if (
      form &&
      typeof form.onActiveFilterClick === 'function'
    ) {
      form.onActiveFilterClick(event);
    }
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define(
    'facet-remove',
    FacetRemove
  );
}

function responsiveCollectionMenu() {
  const filterColumn =
    $('.product-filter-column').first();

  if (!filterColumn.length) return;

  if ($(window).width() < 768) {
    const mobileTarget = $(
      '.product-heading-row ' +
      '.container .row ' +
      '.product-heading-column'
    ).first();

    if (
      mobileTarget.length &&
      !filterColumn.parent().is(mobileTarget)
    ) {
      filterColumn.prependTo(mobileTarget);
    }
  } else {
    const desktopTarget =
      $('.product-list-row').first();

    if (
      desktopTarget.length &&
      !filterColumn.parent().is(desktopTarget)
    ) {
      filterColumn.prependTo(desktopTarget);
    }

    $('body').removeClass(
      'mobile-open ' +
      'no-scroll ' +
      'overflow-hidden-mobile'
    );

    $('.overlay').removeClass('active');
  }
}

function initializeCollectionElements() {
  responsiveCollectionMenu();

  if (
    typeof countDownIni === 'function'
  ) {
    countDownIni(
      '.flip-countdown,.js-flip-countdown'
    );
  }
}

(function initializeCollectionLayout() {
  if (window.collectionLayoutInitialized) {
    return;
  }

  window.collectionLayoutInitialized = true;

  $(document).ready(function () {
    initializeCollectionElements();

    $(document)
      .off('click.collectionFilters')
      .off('click.collectionView')

      .on(
        'click.collectionFilters',
        '.mobile-facets__open',
        function () {
          $('body').addClass(
            'mobile-open no-scroll'
          );

          $('.overlay').addClass('active');
        }
      )

      .on(
        'click.collectionFilters',
        '.overlay, .close-filter, .apply-btn',
        function () {
          $('body').removeClass(
            'mobile-open ' +
            'no-scroll ' +
            'overflow-hidden-mobile ' +
            'filter-open'
          );

          $('.overlay').removeClass('active');
        }
      )

      .on(
        'click.collectionFilters',
        '.collection-leftfilter .filter-title, ' +
        '.collection-rightfilter .filter-title',
        function () {
          $('body').addClass(
            'no-scroll filter-open'
          );

          $('.overlay').addClass('active');
        }
      )

      .on(
        'click.collectionView',
        '.list-view',
        function () {
          $('.list-view').addClass('active');
          $('.grid-view').removeClass('active');

          $('.grid-product .row')
            .removeClass('product-grid-view')
            .addClass('product-list-view');

          $(
            '.product-list-view > .grid__item'
          ).each(function () {
            const item = $(this);

            const productImage =
              item
                .find('.product-card-image')
                .first();

            item
              .find('.product-content-top')
              .insertAfter(productImage);

            item
              .find('.prod-label')
              .prependTo(
                item
                  .find('.product-top-content')
                  .first()
              );

            item
              .find('.stock-label')
              .insertAfter(
                item.find('.prod-label').first()
              );

            item
              .find('.product-des')
              .insertAfter(
                item.find('h3').first()
              );

            item
              .find('.collection-counter')
              .insertAfter(
                item
                  .find('.product-des')
                  .first()
              );

            item
              .find('.product-content-bottom')
              .insertAfter(
                item
                  .find('.product-top-content')
                  .first()
              );

            item
              .find('.rating-wrp')
              .prependTo(
                item
                  .find('.product-content-bottom')
                  .first()
              );

            item
              .find('.price')
              .insertAfter(
                item
                  .find('.rating-wrp')
                  .first()
              );

            item
              .find('.size-select')
              .insertAfter(
                item.find('.price').first()
              );

            item
              .find('.wish-lbl-wrp')
              .insertAfter(
                item
                  .find('.size-select')
                  .first()
              );
          });
        }
      )

      .on(
        'click.collectionView',
        '.grid-view',
        function () {
          $('.grid-view').addClass('active');
          $('.list-view').removeClass('active');

          $('.grid-product .row')
            .addClass('product-grid-view')
            .removeClass('product-list-view');

          $(
            '.product-grid-view > .grid__item'
          ).each(function () {
            const item = $(this);

            const productImage =
              item
                .find('.product-card-image')
                .first();

            item
              .find('.prod-label')
              .appendTo(productImage);

            item
              .find('.stock-label')
              .insertAfter(
                item.find('.prod-label').first()
              );

            item
              .find('.wish-lbl-wrp')
              .appendTo(productImage);

            item
              .find('.rating-wrp')
              .insertBefore(
                item.find('h3').first()
              );

            item
              .find('.collection-counter')
              .insertAfter(
                item
                  .find('.wish-lbl-wrp')
                  .first()
              );

            item
              .find('.product-card-content')
              .insertAfter(productImage);

            item
              .find('.product-content-top')
              .prependTo(
                item
                  .find('.product-card-content')
                  .first()
              );

            item
              .find('.product-content-bottom')
              .insertAfter(
                item
                  .find('.product-content-top')
                  .first()
              );
          });
        }
      );
  });

  $(window)
    .off('resize.collectionFilters')
    .on(
      'resize.collectionFilters',
      responsiveCollectionMenu
    );
})();
/* Remove duplicated collection filters */
(function removeDuplicateCollectionFilters() {
  let cleanupTimer;

  function cleanup() {
    const productGridContainer =
      document.getElementById('ProductGridContainer');

    if (!productGridContainer) return;

    /* Keep only the first complete filter column */
    const filterColumns =
      productGridContainer.querySelectorAll(
        '.product-filter-column'
      );

    filterColumns.forEach((column, index) => {
      if (index > 0) {
        column.remove();
      }
    });

    /* Remove filters accidentally inserted inside product cards */
    const facetContainers =
      productGridContainer.querySelectorAll(
        '.facets-container.product-filter-body'
      );

    facetContainers.forEach((facet, index) => {
      if (index === 0) return;

      const incorrectProductCard =
        facet.closest('.grid__item');

      const incorrectColumn =
        facet.closest('.product-filter-column');

      if (incorrectProductCard) {
        incorrectProductCard.remove();
      } else if (
        incorrectColumn &&
        incorrectColumn !== filterColumns[0]
      ) {
        incorrectColumn.remove();
      } else {
        facet.remove();
      }
    });
  }

  function scheduleCleanup() {
    window.clearTimeout(cleanupTimer);

    cleanupTimer = window.setTimeout(
      cleanup,
      50
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleCleanup
    );
  } else {
    scheduleCleanup();
  }

  window.addEventListener(
    'load',
    scheduleCleanup
  );

  const observer = new MutationObserver(
    scheduleCleanup
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();